import axios from 'axios';
import * as _ from 'lodash'

class SupportService {

  /**
   * Retorna os veiculos que precisam ser ativados
   *
   * @returns Promise<Object> Lista veiculos
   */
  faleConosco(faleConosco) {
    return axios.post('/v2/faleConosco',faleConosco);
  }
}

// Singleton
const instance = new SupportService();
export default instance;



// WEBPACK FOOTER //
// ./src/services/support.js